import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  border-radius: 3px;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: ${p => p.theme.spacing(12)};

  & > * + * {
    border-left: 1px solid #ddd;
  }

  @media (${p => p.theme.mq.desktop}) {
    max-width: 80%;
  }
`;

export const BlockRadio = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex: 1;
  justify-content: center;
  padding: ${p => p.theme.spacing(4)};
  position: relative;
  text-align: center;

  @media (${p => p.theme.mq.desktop}) {
    line-height: 18px;
  }

  & span {
    color: ${p => (p.selected ? '#fff' : '#000')};
    z-index: 3
    transition: color .2s ease;
  }

  &:hover {
    background-color: ${p => p.theme.color.tealLight};
  }

  &::before {
    background-color: ${p => p.theme.color.teal};
    content: '';
    height: 100%;
    left:0;
    position:absolute;
    top:0;
    transform: scale(0);
    transition: transform .2s ease;
    width: 100%;
  }

  ${p =>
    p.selected &&
    css`
      &::before {
        transform: scale(1);
      }
    `}
`;

export const Title = styled.p`
  font-weight: bold;
  margin: 0;
`;

export const Description = styled.p`
  margin: -4px 0 10px 0;
  font-size: 14px;
`;



// WEBPACK FOOTER //
// ./src/components/BlockRadioButtons/styles.js